import { Directive, ElementRef, Renderer2, Input } from '@angular/core';
import * as VMasker from 'vanilla-masker';

@Directive({
    selector: '[MaskInput]',
})
export class MaskInputDirective {

    @Input() public maskOption;
    public nativeElement: HTMLInputElement;

    constructor(
        public element: ElementRef,
        public render: Renderer2,
    ) {
        this.nativeElement = this.element.nativeElement;
    }

    public ngOnInit() {
        if (this.maskOption === 'cep') {
            VMasker(this.nativeElement)
                .maskPattern('99.999-999');
        }
    }
}
